export function scrollToFirstError(errors: Record<string, any>, prefix = ''): boolean {
  for (const key of Object.keys(errors)) {
    const fullKey = prefix ? `${prefix}.${key}` : key
    const value = errors[key]

    if (value?.message || value?.type) {
      const el = document.querySelector<HTMLElement>(`[name="${fullKey}"]`)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        el.focus({ preventScroll: true })
        return true
      }
    }
    else if (typeof value === 'object' && value !== null) {
      const found = scrollToFirstError(value, fullKey)
      if (found)
        return true
    }
  }
  return false
}
